// var sortedInfo = {}
export default {
  pagination: true,
  full: false,
  scroll: { x: 1360, y: 610 },
  columns: [
    { align: 'center', title: '序号', dataIndex: 'num', key: 'num', width: 60, scopedSlots: { customRender: 'num' } },
    { title: '组件名称', dataIndex: 'name', width: 206 },
    { title: '组件类别', dataIndex: 'controlType', width: 116, scopedSlots: { customRender: 'controlType' } },
    { title: '组件子类别', dataIndex: 'controlSonType', width: 256, scopedSlots: { customRender: 'controlSonType' } },
    { title: '作者', dataIndex: 'author', width: 102, scopedSlots: { customRender: 'author' } },
    { title: '更新时间', dataIndex: 'hexUpdateTime', width: 108, scopedSlots: { customRender: 'hexUpdateTime' }, defaultSortOrder: 'descend', sorter: (a, b) => a.hexUpdateTime - b.hexUpdateTime },
    { title: '新建时间', dataIndex: 'hexCreateTime', width: 108, scopedSlots: { customRender: 'hexCreateTime' }, defaultSortOrder: 'descend', sorter: (a, b) => a.hexCreateTime - b.hexCreateTime },
    { title: '使用次数', dataIndex: 'useCount', width: 108, scopedSlots: { customRender: 'useCount' }, defaultSortOrder: 'descend', sorter: (a, b) => a.useCount - b.useCount },
    { title: '操作', dataIndex: '_id', fixed: 'right', width: 240, scopedSlots: { customRender: 'action' } }
  ],
  columns2: [
    { align: 'center', title: '序号', dataIndex: 'num', key: 'num', width: 120, scopedSlots: { customRender: 'num' } },
    { title: '组件类别', dataIndex: 'parentTypeName', width: 298, scopedSlots: { customRender: 'parentTypeName' } },
    { title: '组件子类别', dataIndex: 'name', width: 298, scopedSlots: { customRender: 'name' } },
    { title: '是否显示', dataIndex: 'isShow', width: 298, scopedSlots: { customRender: 'isShow' } },
    { title: '操作', dataIndex: '_id', width: 298, scopedSlots: { customRender: 'action' } }
  ]
}
